import ContinuousTestingSetup from './ContinuousTestingSetup'

export default function TestingSchedules({ projectId, canEdit }: { projectId: string; canEdit: boolean }) {
  return <ContinuousTestingSetup projectId={projectId} canEdit={canEdit} />
}
